export const environment = {
    production: true,
    hmr: false,
    apiBaseUrl: "https://forms-api.alec.ae",
    azureAd: {
        clientId: "33974ee1-78e4-4706-b729-3485b84e7d35",
        authority: "https://login.microsoftonline.com/alec4.onmicrosoft.com",
        redirectUri: "/",
        apiClientId: "7ae9c819-5a05-485f-aa76-aa346c476ddd",
    },
};
